/* Kora content — table of contents, copy/share links, form message focus. No dependencies. */
(() => {
  const K = window.Kora || {};

  /* Copy link + share: <kora-share data-url="..."> with [data-copy-link] button */
  if (!customElements.get('kora-share')) {
    class KoraShare extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-copy-link]');
        if (!btn) return;
        const label = btn.querySelector('[data-copy-label]');
        const original = label ? label.textContent : '';
        btn.addEventListener('click', async () => {
          const url = this.dataset.url || location.href;
          let ok = false;
          try {
            await navigator.clipboard.writeText(url);
            ok = true;
          } catch (e) {
            const ta = document.createElement('textarea');
            ta.value = url;
            ta.setAttribute('readonly', '');
            ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
            document.body.appendChild(ta);
            ta.select();
            try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
            ta.remove();
          }
          if (!ok) return;
          const done = btn.dataset.copied || '';
          if (label && done) label.textContent = done;
          if (K.announce && done) K.announce(done);
          clearTimeout(this._t);
          this._t = setTimeout(() => { if (label) label.textContent = original; }, 2200);
        });
      }
    }
    customElements.define('kora-share', KoraShare);
  }

  /* Table of contents generated from h2/h3 of [data-toc-content] */
  if (!customElements.get('kora-toc')) {
    const slugify = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    class KoraToc extends HTMLElement {
      connectedCallback() {
        const content = document.querySelector(this.dataset.target || '[data-toc-content]');
        const list = this.querySelector('[data-toc-list]');
        if (!content || !list) { this.hidden = true; return; }
        const heads = Array.from(content.querySelectorAll('h2, h3')).filter((h) => h.textContent.trim());
        if (heads.length < 2) { this.hidden = true; return; }
        const used = new Set();
        const frag = document.createDocumentFragment();
        heads.forEach((h) => {
          let id = h.id || slugify(h.textContent) || 'seccion';
          let n = 2;
          const base = id;
          while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== h)) id = `${base}-${n++}`;
          used.add(id);
          h.id = id;
          const li = document.createElement('li');
          if (h.tagName === 'H3') li.className = 'toc__sub';
          const a = document.createElement('a');
          a.href = `#${id}`;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          frag.appendChild(li);
        });
        list.appendChild(frag);
      }
    }
    customElements.define('kora-toc', KoraToc);
  }

  /* Move focus to form result messages (success / errors) */
  const focusMessage = () => {
    const el = document.querySelector('[data-autofocus]');
    if (el) el.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusMessage);
  else focusMessage();
})();
